export const ErrorCodes = {
	ERR_NO_ENOUGH_PERMS: 'NO_ENOUGH_PERMS',
	ERR_NO_ENOUGH_SLOTS: 'NO_ENOUGH_SLOTS',
	SLOT_ALREADY_ASSIGNED: 'SLOT_ALREADY_ASSIGNED',
	CANDIDATE_ALREADY_ASSIGNED: 'CANDIDATE_ALREADY_ASSIGNED',
	APPLICATION_NOT_ELGIBLE_FOR_INTERVIEW: 'APPLICATION_NOT_ELGIBLE_FOR_INTERVIEW',
	CANDIDATE_NOT_APPLIED: 'CANDIDATE_NOT_APPLIED'
};
